import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { SignaturesHeaderService } from 'src/app/services/signatures-header.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-signatory-verify-otp-code',
  templateUrl: './signatory-verify-otp-code.component.html',
  styleUrls: ['./signatory-verify-otp-code.component.sass']
})
export class SignatoryVerifyOtpCodeComponent implements OnInit, AfterViewInit {

  form:FormGroup;

  @ViewChild('firstInput') firstInput:ElementRef<HTMLInputElement> = {} as ElementRef;
  @ViewChild('secondInput') secondInput:ElementRef<HTMLInputElement> = {} as ElementRef;
  @ViewChild('thirdInput') thirdInput:ElementRef<HTMLInputElement> = {} as ElementRef;
  @ViewChild('forthInput') forthInput:ElementRef<HTMLInputElement> = {} as ElementRef;

  public loading:boolean = false;
  public error:boolean = false;
  public error_message:string = "";
  public email:string = null as any;
  public name:string = null as any;
  private signature_uuid:string = "";
  public retry_enabled:boolean = false;

  constructor(private header:SignaturesHeaderService,
              private fb:FormBuilder,
              private auth:AuthService,
              private router:Router,
              private utils:UtilsService,
              private recaptchaV3Service: ReCaptchaV3Service,
              private api:ApiService) {
    this.form = this.fb.group({
      first: [ '', Validators.compose([ Validators.required, Validators.min(0), Validators.max(9) ]) ],
      second: [ '', Validators.compose([ Validators.required, Validators.min(0), Validators.max(9) ]) ],
      third: [ '', Validators.compose([ Validators.required, Validators.min(0), Validators.max(9) ]) ],
      forth: [ '', Validators.compose([ Validators.required, Validators.min(0), Validators.max(9) ]) ],
    });
  }

  ngOnInit(): void {
    this.header.closeHeader();
    this.header.setAuthStep(1);
    this.listenAuthProcess();
    this.waitForRetrying();
  }

  ngAfterViewInit(): void {
    this.focusFirstInput();
    this.listenInputs();
    this.firstInputOnPaste();
  }

  submit() {
    this.loading = true;
    this.error = false;
    this.auth.loginOtp(this.getOtp()).subscribe(
      data => {
        this.loading = false;
        this.router.navigate(['/signatures', this.signature_uuid]);
      },
      error => {
        this.loading = false;
        this.error = true;
        this.error_message = error.error.message;

      }
    );
  }

  retryRequestOtp() {
    this.retry_enabled = false;
    this.recaptchaV3Service.execute('request_otp').subscribe(
      token => {
        const login_process = this.auth.getLoginProcess();
        this.api.requestOtp(login_process.email, login_process.signature_request_uuid, token).subscribe(
          data => {
            this.waitForRetrying(); // tornem a esperar 30 segons
          },
          error => {
            this.retry_enabled = true;
          }
        );
      },
      error => {
        this.retry_enabled = true;
      }
    );
  }

  private focusFirstInput() {
    this.firstInput.nativeElement.focus();
  }

  private listenInputs() {
    // first input
    this.firstInput.nativeElement.addEventListener('keyup', (e) => {
      this.error = false;
      const val = (e.target as any).valueAsNumber;
      if(!isNaN(val)) {
        if(val > 9) this.form.controls['first'].setValue('');
        else this.secondInput.nativeElement.focus();
      }
    });

    // second input
    this.secondInput.nativeElement.addEventListener('keyup', (e) => {
      this.error = false;
      const val = (e.target as any).valueAsNumber;
      if(!isNaN(val)) {
        if(val > 9) this.form.controls['second'].setValue('');
        else this.thirdInput.nativeElement.focus();
      }
      else if(this.form.controls['third'].value==null && this.form.controls['forth'].value==null) this.firstInput.nativeElement.focus();
    });

    // third input
    this.thirdInput.nativeElement.addEventListener('keyup', (e) => {
      this.error = false;
      const val = (e.target as any).valueAsNumber;
      if(!isNaN(val)) {
        if(val > 9) this.form.controls['third'].setValue('');
        else this.forthInput.nativeElement.focus();
      }
      else if(this.form.controls['forth'].value==null) this.secondInput.nativeElement.focus();
    });

    // forth input
    this.forthInput.nativeElement.addEventListener('keyup', (e) => {
      this.error = false;
      const val = (e.target as any).valueAsNumber;
      if(!isNaN(val)) {
        if(val > 9) this.form.controls['forth'].setValue('');
        else {
          this.forthInput.nativeElement.blur();
          this.submit();
        }
      }
      else this.thirdInput.nativeElement.focus();
    });
  }

  private firstInputOnPaste() {
    this.firstInput.nativeElement.addEventListener('paste', async (e:any) => {
      e.preventDefault();

      const text = await navigator.clipboard.readText();
      if(text != null) { // En localhost, safari, no es pot fer servir el clipboard perque no es window.isSecureContext. Vaja, https.
        const val = +text;

        if(!isNaN(val) && val <= 9999) {
          const first = val<1000 ? 0 : Math.floor(val / 1000);
          const second = val<100 ? 0 : Math.floor(val % 1000 / 100);
          const third = val<10 ? 0 : Math.floor(val % 100 / 10);
          const forth = val==0 ? 0 : Math.floor(val % 10);

          this.form.controls['first'].setValue(first);
          this.form.controls['second'].setValue(second);
          this.form.controls['third'].setValue(third);
          this.form.controls['forth'].setValue(forth);

          this.firstInput.nativeElement.blur();

          this.submit();
        }
      }
    });
  }

  private getOtp() {
    return  this.form.controls['first'].value.toString() +
            this.form.controls['second'].value.toString() +
            this.form.controls['third'].value.toString() +
            this.form.controls['forth'].value.toString();
  }

  private listenAuthProcess() {
    this.auth.loginProcess.subscribe(
      data => {
        if(data != null) {
          this.email = data.email;
          this.name = data.name;
          this.signature_uuid = data.signature_request_uuid;
        }
      }
    );
  }

  private async waitForRetrying() {
    const SECONDS = 30;
    await this.utils.delay(SECONDS * 1000); // esperamos 30 segundos
    this.retry_enabled = true;
  }

}
